import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import common_en from "./resources/en/common.json";
import common_fr from "./resources/fr/common.json";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      common: common_en,
    },
    fr: {
      common: common_fr,
    },
  },
  lng: "en",

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
